import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../../../commons/services/http.service';
import { BaseReponseGeneric } from '../../../../commons/class/BaseReponseGeneric.interface';
import { map, Observable } from 'rxjs';
import { Documents } from '../../../../commons/class/archivo.inteface';
import { ENV_TOKEN } from '../../../../app-module.token';

export interface EnrollmentMovements {
  kIdAutoEnrolamiento: number;
  fkIdCatTipoOrganismo: number;
  sNombreOficial: string | null;
  sAutoridad: string;
  sSolicitante: string;
  sCorreoInstitucion: string;
  sCorreoSolicitante: string;
  sTelSolicitante: string;
  sObservaciones: string;
  iStatusSolicitud: number;
  bStatusReg: boolean;
  iDocumentos: number;
  sGUID: string | null;
  usuarioRevisor: string;
  sentidoDictaminacion: string;
  iDocumentoAceptacion: number;
  historialEstatus: string;
  entidadFederativa: string;
  fechaRegistro: string | null;
  fechaDictamen: string | null;
  fechaRechazo: string | null;
  sTextoAdicional: string | null;
  sMotivoRechazo: string | null;
}

export interface sendEmailRequest {
  Id: number;
  UsuarioId: number;
}

export interface sendEmailResponse {
  succcess: boolean;
  data: boolean;
  message: string;
}

export interface sendEmailValidacionRequest {
  idAutoEnrolamiento: number;
  autoridad: string;
  correoInstitucion: string;
}

export interface sendEmailValidacionResponse {
  succcess: boolean;
  data: boolean;
  message: string;
}

export interface estatusSolicitudRegistroRequest {
  idAutoEnrolamiento: number;
  idEstatusSolicitud: number;
  idEmpleado: number;
  sIP: string;
}

export interface estatusSolicitudRegistroResponse {
  succcess: boolean;
  data: boolean;
  message: string;
}

export interface getBitacoraEstatusResponse {
  id: number;
  idAutoEnrolamiento: number;
  fechaMovimiento: string;
  estatusSolicitud: number;
  empleadoId: number;
  nombre: string;
  apellidoPaterno: string;
  apellidoMaterno: string;
}
@Injectable({
  providedIn: 'root',
})
export class Service {

  headers = new HttpHeaders();
  public constService: any;
  urlRaiz!: string;
  private httpService: HttpService = inject(HttpService);
  readonly environment = inject(ENV_TOKEN);

  constructor() {
    this.constService = this.environment;
    this.urlRaiz = this.constService.gateway;
  }


  /**
   * Obtiene los movimientos de auto enrolamiento por fecha de inicio, fecha de fin y estatus, se construye la ruta para la consulta utilizando la URL raíz y la función correspondiente, se agregan los parámetros de fecha de inicio, fecha de fin y estatus a la ruta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta del servicio como un Observable con un objeto genérico que contiene un array de movimientos de auto enrolamiento
   * @param fechaInicio 
   * @param fechaFin 
   * @param estatus 
   * @returns 
   */
  getMovAutoEnrolamiento(fechaInicio: string, fechaFin: string, estatus: number): Observable<BaseReponseGeneric<EnrollmentMovements[]>> {
    const funcion = "icoij/AutoEnrolamiento";
    const ruta = `${this.urlRaiz}/${funcion}/${estatus}/${fechaInicio}/${fechaFin}`;
    return this.httpService.getRequest(ruta).pipe(map((resp: any) => resp ?? { succcess: true, data: [] }));
  }

  /**
   * Obtiene los documentos de auto enrolamiento por ID de configuración y tipo de documento, se construye la ruta para la consulta utilizando la URL raíz y la función correspondiente, se agregan los parámetros de ID de configuración y tipo de documento a la ruta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta del servicio como un Observable con un array de documentos
   * @param idConfiguracion 
   * @param tipoDocumento 
   * @returns 
   */
  obtenerDocumentosAutoEnrolamiento(
    idConfiguracion: number,
    tipoDocumento: number
  ): Observable<Documents[]> {
    const url = `oaj.icoij.gateway/icoij/getDocumentosByIdTrans/${idConfiguracion}/${tipoDocumento}`;
    return this.httpService.getRequest(url).pipe(
      map((resp: any) => {
        if (resp?.succcess) {
          if (Array.isArray(resp.data)) {
            return resp.data as Documents[];
          }
          if (resp.data?.$values && Array.isArray(resp.data.$values)) {
            return resp.data.$values as Documents[];
          }
        }
        return [] as Documents[];
      })
    ) as Observable<Documents[]>;
  }

  /**
   * Reenvía un correo de validación, se construye la ruta para el reenvío utilizando la URL raíz y la función correspondiente, se hace una petición POST al servicio utilizando la ruta construida y el objeto de solicitud proporcionado, se retorna la respuesta del servicio como un Observable con un objeto genérico que contiene la información del reenvío de correo
   * @param request 
   * @returns 
   */
  reenvioCorreo(request: sendEmailRequest): Observable<sendEmailResponse> {
    const funcion = "icoij/AutoEnrolamiento/ReenvioCorreo";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request) as Observable<sendEmailResponse>;
  }

  /**
   * Reenvía un correo de validación, se construye la ruta para el reenvío utilizando la URL raíz y la función correspondiente, se hace una petición POST al servicio utilizando la ruta construida y el objeto de solicitud proporcionado, se retorna la respuesta del servicio como un Observable con un objeto genérico que contiene la información del reenvío de correo
   * @param request 
   * @returns 
   */
  reenvioCorreoValidacion(request: sendEmailValidacionRequest): Observable<sendEmailValidacionResponse> {
    const funcion = "icoij/ReenvioCorreoRegistro";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request) as Observable<sendEmailValidacionResponse>;
  }

  /**
   * Actualiza el estatus de una solicitud de registro, se construye la ruta para la actualización utilizando la URL raíz y la función correspondiente, se hace una petición POST al servicio utilizando la ruta construida y el objeto de solicitud proporcionado, se retorna la respuesta del servicio como un Observable con un objeto genérico que contiene la información de la actualización
   * @param request 
   * @returns 
   */
  actualizarEstatusSolicitudRegistro(request: estatusSolicitudRegistroRequest): Observable<estatusSolicitudRegistroResponse> {
    const funcion = "icoij/ActualizarEstatusSolicitud";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request) as Observable<estatusSolicitudRegistroResponse>;
  }

  /**
   * Obtiene la bitácora de estatus de un autoenrolamiento, se construye la ruta para la consulta utilizando la URL raíz y la función correspondiente, se agrega el ID de autoenrolamiento a la ruta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta del servicio como un Observable con un objeto genérico que contiene el array de cambios de estatus
   * @param idAutoenrolamiento 
   * @returns 
   */
  getBitacoraEstatus(idAutoenrolamiento: number): Observable<BaseReponseGeneric<getBitacoraEstatusResponse[]>> {
    const funcion = "icoij/GetBitacoraCambiosEstatus";
    const ruta = `${this.urlRaiz}/${funcion}/${idAutoenrolamiento}`;
    return this.httpService.getRequest(ruta).pipe(map((resp: any) => resp ?? { succcess: true, data: [] }));
  }
}
